import { TranslationKey } from './../../../../types/translation/TranslationKey';

import React from 'react';
import { JSX } from 'react';
import { BinStatus } from '../../../../types/bin/binStatus';
import { t } from '../../../../types/translation/Translator';
import { BinStatusFilterDropdownContent, BinStatusFilterInnerContent } from './DropdownContent';
import { BinIcon } from '../../../icons/Bin/BinIcon';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { toFilterString } from '../../../../util/string.util';
import { FilterProps } from '../common/filter.util';

export class BinStatusFilter extends BaseFilter<BinStatus> {
  toLabel(): string {
    return t(TranslationKey.binStatus).singular.label;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.binStatus?.size || 0;
  }

  toIcon(): JSX.Element {
    return <BinIcon />;
  }

  search(item: BinStatus, textFilter: string) {
    if (toFilterString(item.status).includes(textFilter)) {
      return true;
    }

    return false;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return (
      <BinStatusFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <BinStatusFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  static filter(filterProps: FilterProps, item?: BinStatus) {
    if (item && filterProps.binStatus?.size && !filterProps.binStatus.has(item.id)) return false;
    return true;
  }
}
